"use client";

import React, { useEffect, useState } from "react";
import "./Job.css";

// import { useNavigate, useParams } from "react-router";
// import Seo from "../components/Seo";
// import { Link } from 'react-router-dom';
// import { CountryList } from "../services/CountryList";
// import { CareerFileUpload } from "../services/CareerFileUpload";
// import { CareerInquiry } from "../services/CareerInquiry";
import api from "@/helper/api.interceptor";
import { Toast } from "@/components/Toast";
import {
  setInquiryPopupObj,
  setThankYouData,
} from "@/store/slices/inquirySlice";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";

function Job({ joblist = [] }) {
  const [activeJob, setActiveJob] = useState(
    joblist?.length ? joblist[0].id : null,
  );

  const [isCareerForm, setIsCareerForm] = useState(false);
  const [activeCareerData, setActiveCareerData] = useState(null);

  const selectedJob = joblist.find((job) => job.id === activeJob);

  useEffect(() => {
    document.body.style.overflow = isCareerForm ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isCareerForm]);

  const dispatch = useDispatch();
  const router = useRouter();
  //   const navigate = useNavigate();
  const [inquiryObj, setInquiryObj] = useState({
    name: "",
    contact_no_display: "",
    current_company: "",
    current_designation: "",
    contact_no: "",
    resume: "",
    email: "",
    from_app: "true",
    master_user_id: "632",
    logged_in_master_user_id: "632",
    flag: "https://flagcdn.com/w40/in.webp",
    country: "91",
  });

  // const [CareerDetailsData, setCareerDetailsData] = useState(CareerDetail || null);
  const [activeAccordion, setActiveAccordion] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [countryFlag, setCountryFlag] = useState(false);
  // const [countryList, setCountryList] = useState([]);
  const [search, setSearch] = useState("");
  const [errors, setErrors] = useState({});

  const [resumeFile, setResumeFile] = useState(null);

  const countryList = useSelector((state) => state.inquiry.countryList);

  const allowedExtensions = ["pdf", "doc", "docx"];

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        setResumeFile(null);
        return;
      } else {
        let data = {
          from_app: true,
          upload_type: "resume",
          resume_upload: file,
        };

        // console.log(data);

        const response = await api.CareerFileUpload(data);

        // console.log(response);

        if (response.success == 1) {
          setResumeFile(file);
          if (data.upload_type == "resume") {
            setInquiryObj((prev) => ({
              ...prev,
              resume: response.file_name,
            }));
          }
        } else {
          Toast(response.message);
          //   toast(response.message, {
          //     position: "bottom-right",
          //     autoClose: 3000,
          //     hideProgressBar: true,
          //     closeOnClick: true,
          //     rtl: false,
          //     pauseOnFocusLoss: false,
          //     draggable: false,
          //     pauseOnHover: false,
          //     style: {
          //       background: "#000",
          //       color: "#fff",
          //       fontSize: "14px",
          //     },
          //   });
        }
      }
    }
  };

  const career_click = (data) => {
    console.log("open");

    setIsCareerForm(true);
    setActiveCareerData(data);
  };

  const accordionClick = (id) => {
    if (activeAccordion == id) {
      setActiveAccordion("");
    } else {
      setActiveAccordion(id);
    }
  };

  // const seoMetaData = CareerDetailsData && {
  //     page_title: CareerDetailsData.seo_title || "Career | Swati Procon",
  //     page_description: CareerDetailsData.seo_description,
  //     page_keywords: CareerDetailsData.seo_keywords,
  //     slug: CareerDetailsData.slug,
  //     image: CareerDetailsData.seo_image_full
  //         ? (CareerDetailsData.seo_image_full.includes("?")
  //             ? `${CareerDetailsData.seo_image_full}&w=1280&h=640`
  //             : `${CareerDetailsData.seo_image_full}?w=1280&h=640`)
  //         : "/images/og-img.jpeg"
  // };

  useEffect(() => {
    // async function loadCountry() {
    //   try {
    //     const data = await api.CountryList();
    //     const filtered = data.filter((c) => c.phonecode !== "92");
    //     setCountryList(filtered);
    //   } catch (error) {
    //     console.error("Error loading countries", error);
    //   }
    // }
    // loadCountry();
    // console.log(CareerDetailsData)
    // let dataToUse;
    // if (CareerDetailsData != null) {
    //     dataToUse = CareerDetailsData;
    // } else {
    //     dataToUse = pageList.find(project => project.slug === "career");
    // }
    // if (dataToUse) {
    //     setCareerDetailsData(dataToUse);
    // }
  }, []);

  const validate = () => {
    let newErrors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

    if (!inquiryObj.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!nameRegex.test(inquiryObj.name)) {
      newErrors.name = "Name must contain only letters";
    }

    if (!inquiryObj.contact_no_display.trim()) {
      newErrors.contact_no_display = "Contact number is required";
    } else if (!phoneRegex.test(inquiryObj.contact_no_display)) {
      newErrors.contact_no_display = "Contact number must be 10 digits";
    }

    if (!inquiryObj.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(inquiryObj.email)) {
      newErrors.email = "Invalid email format";
    }

    // ✅ Department validation
    if (!inquiryObj.current_company || inquiryObj.current_company === "") {
      newErrors.current_company = "current company is required";
    }
    if (
      !inquiryObj.current_designation ||
      inquiryObj.current_designation === ""
    ) {
      newErrors.current_designation = "current designation is required";
    }
    if (!inquiryObj.resume || inquiryObj.resume === "") {
      newErrors.resume = "resume is required";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    setFormSubmitted(false);

    if (name === "name") {
      updatedValue = value.replace(/[0-9]/g, "");
    }
    if (name === "contact_no_display") {
      updatedValue = value.replace(/[^0-9]/g, "").slice(0, 10);
    }
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(updatedValue)) {
        setErrors((prev) => ({
          ...prev,
          email: "Invalid email format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          email: "",
        }));
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    setInquiryObj((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCountrySelect = (phonecode, flag) => {
    setInquiryObj((prev) => ({
      ...prev,
      country: phonecode,
      flag,
    }));
    setCountryFlag(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const contact_no = inquiryObj.country + " " + inquiryObj.contact_no_display;
    const finalInquiry = {
      ...inquiryObj,
      contact_no,
    };

    try {
      const response = await api.CareerInquiry(finalInquiry);
      //   console.log("Inquiry submitted:", response);

      //   navigate(`/career/thankyou`, {
      //     state: {
      //       name: "Career",
      //     },
      //   });

      // Reset form
      if (response.success) {
        setIsCareerForm(false);
        setInquiryObj((prev) => ({
          ...prev,
          name: "",
          contact_no_display: "",
          contact_no: "",
          email: "",
          resume: "",
          current_company: "",
          current_designation: "",
        }));
        setErrors({});
      }
      setFormSubmitted(false);

      dispatch(
        setThankYouData({
          page_name: "Career",
          document: [],
        }),
      );
      router.push(`/career/thankyou`);

      Toast(response.message);
    } catch (err) {
      console.error("Submission error:", err);
      setFormSubmitted(false);
    }
  };
  const [isMobilescreen, setMobilescreen] = useState(false);

  useEffect(() => {
    if (window.innerWidth <= 767) setMobilescreen(true);
    dispatch(setInquiryPopupObj(null));
  }, []);

  useEffect(() => {
    setCountryFlag(false);
    if (isCareerForm) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isCareerForm]);

  return (
    <>
      {/* <div className="job-wrapper section-padding relative">
        <div className="main-container-fluid">
          <div className="section-paragraph2">
            <p className="semibold-fonts">Job Openings</p>
          </div>

          <div className="job-border1"></div>

          <div className="flex-row job-main">
          

            <div className="inner-flex inner-flex-medium40 job-part1">
              {joblist?.map((job) => (
                <div key={job.id} onClick={() => setActiveJob(job.id)}>
                  <div className="flex-row j-c-sb section-subtitle">
                    <h4 className="semibold-fonts">{job.position}</h4>

                    <span className="job-plus-sign">
                      {activeJob === job.id ? "×" : "+"}
                    </span>
                  </div>

                  <div className="section-content22">
                    <p className="regular-fonts">{job.exp_years}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="job-border2 hide-tab-mobile"></div>

        

            <div className="job-part3">
              <div className="job-part3-1">
                <div className="section-paragraph2">
                  <p className="semibold-fonts">Description</p>
                </div>

                <div className="job-list1">
                  {selectedJob && (
                    <div
                      className="section-content22 regular-fonts"
                      dangerouslySetInnerHTML={{
                        __html: selectedJob.description,
                      }}
                    />
                  )}
                </div>

                <div className="job-button">
                  <button
                    className="reecosys-template-button button-style-secondary"
                    onClick={() => career_click(selectedJob)}
                  >
                    <p>Apply Now</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Overlay */}

      {/* <div
        className={`click-overlay ${isCareerForm ? "active" : ""}`}
        onClick={() => setIsCareerForm(false)}
      /> */}

      {/* Popup */}
      <div className="section-paddinglarge light-bg-section  ">
        <div className="inner-flex form-container">
          <div className="section-title">
            <h2>Join Our Team</h2>
          </div>

          <div className="section-paragraph inner-flex">
            {activeCareerData && (
              <>
                <p>{activeCareerData.position}</p>

                <p>{activeCareerData.exp_years}</p>
              </>
            )}
          </div>
          <form
            id="career_form"
            name="career_form"
            onSubmit={handleSubmit}
            onClick={() => {
              setCountryFlag(false);
            }}
          >
            <div className="form_wrapper job-wrapper-form">
              <div className="contact_lable">
                <input
                  id="name"
                  name="name"
                  type="text"
                  className={`form-control  ${
                    inquiryObj.name ? "ng-not-empty" : "ng-empty"
                  } ${errors.name ? "ng-invalid" : "ng-valid"} ${
                    inquiryObj.name ? "ng-touched" : ""
                  } ${formSubmitted && errors.name ? "error" : ""}`}
                  value={inquiryObj.name}
                  onChange={handleChange}
                  tabIndex={1}
                />
                <label className="md-lable" htmlFor="name">
                  Name
                </label>
                <div className="valid-icon-of-form">
                  <img
                    loading="lazy"
                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                    alt="valid"
                  />
                </div>
              </div>

              <div className="contact_lable">
                <input
                  id="email"
                  name="email"
                  type="email"
                  className={`form-control   ${
                    inquiryObj.email ? "ng-not-empty" : "ng-empty"
                  } ${formSubmitted && errors.email ? "error" : ""} ${
                    errors.email ? "ng-invalid" : "ng-valid"
                  } ${inquiryObj.email ? "ng-touched" : ""}`}
                  value={inquiryObj.email}
                  onChange={handleChange}
                  tabIndex={2}
                />
                <label className="md-lable" htmlFor="email">
                  Email
                </label>
                <div className="valid-icon-of-form">
                  <img
                    loading="lazy"
                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                    alt="valid"
                  />
                </div>
              </div>

              {/* Contact Number */}
              <div className="contact_lable relative">
                <span className="material-symbols-outlined icon-form-control">
                  dialpad
                </span>
                <input
                  id="contact_no_display"
                  name="contact_no_display"
                  type="text"
                  className={`form-control  contact-form form-control-iconpad ${
                    inquiryObj.contact_no_display ? "ng-not-empty" : "ng-empty"
                  } ${
                    formSubmitted && errors.contact_no_display ? "error" : ""
                  } ${
                    !errors.contact_no_display &&
                    inquiryObj.contact_no_display.length === 10
                      ? "ng-valid"
                      : "ng-invalid"
                  } ${inquiryObj.contact_no_display ? "ng-touched" : ""}`}
                  value={inquiryObj.contact_no_display}
                  onChange={handleChange}
                  minLength="10"
                  maxLength="10"
                  tabIndex={3}
                />
                <label
                  className="md-lable contact_code"
                  htmlFor="contact_no_display"
                >
                  Mobile Number
                </label>
                <div className="valid-icon-of-form">
                  <img
                    loading="lazy"
                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                    alt="valid"
                  />
                </div>
                <div className="conatct_number_input">
                  <div
                    className="country_code_data"
                    onClick={(e) => {
                      setCountryFlag((prev) => !prev);
                      e.stopPropagation();
                    }}
                  >
                    <div className="contact_country_flag">
                      <img
                        loading="lazy"
                        src={inquiryObj.flag}
                        alt="country-flag"
                      />
                    </div>
                    <div>&nbsp;+{inquiryObj.country}</div>
                    <div>
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>

                <div
                  className={`country_code_list_data ${
                    countryFlag ? "active" : ""
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="search_c-code">
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search"
                    />
                  </div>
                  <ul>
                    {countryList
                      .filter(
                        (item) =>
                          item.phonecode.toString().includes(search) ||
                          item.nicename
                            .toLowerCase()
                            .includes(search.toLowerCase()),
                      )
                      .map((item, index) => (
                        <li key={`${item.phonecode}-${item.nicename}-${index}`}>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCountrySelect(item.phonecode, item.flag);
                            }}
                          >
                            <div>
                              <img src={item.flag} alt="country" />
                            </div>
                            <span className="display_country_code">
                              +{item.phonecode}
                            </span>{" "}
                            {item.nicename}
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="form_wrapper contact_form">
                <div className="contact_lable">
                  <span className="material-symbols-outlined icon-form-control">
                    business
                  </span>
                  <input
                    id="current_company"
                    name="current_company"
                    type="text"
                    className={`form-control  form-control-iconpad ${
                      inquiryObj.current_company ? "ng-not-empty" : "ng-empty"
                    } ${errors.current_company ? "ng-invalid" : "ng-valid"} ${
                      inquiryObj.current_company ? "ng-touched" : ""
                    } ${formSubmitted && errors.current_company ? "error" : ""}`}
                    value={inquiryObj.current_company}
                    onChange={handleChange}
                    tabIndex={4}
                  />
                  <label className="md-lable" htmlFor="current_company">
                    Current Company
                  </label>
                  <div className="valid-icon-of-form">
                    <img
                      loading="lazy"
                      src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                      alt="valid"
                    />
                  </div>
                </div>
              </div>
              <div className="form_wrapper contact_form">
                <div className="contact_lable">
                  <span className="material-symbols-outlined icon-form-control">
                    business
                  </span>
                  <input
                    id="current_designation"
                    name="current_designation"
                    type="text"
                    className={`form-control  form-control-iconpad ${
                      inquiryObj.current_designation
                        ? "ng-not-empty"
                        : "ng-empty"
                    } ${
                      errors.current_designation ? "ng-invalid" : "ng-valid"
                    } ${inquiryObj.current_designation ? "ng-touched" : ""} ${
                      formSubmitted && errors.current_designation ? "error" : ""
                    }`}
                    value={inquiryObj.current_designation}
                    onChange={handleChange}
                    tabIndex={5}
                  />
                  <label className="md-lable" htmlFor="current_designation">
                    Current Designation
                  </label>
                  <div className="valid-icon-of-form">
                    <img
                      loading="lazy"
                      src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                      alt="valid"
                    />
                  </div>
                </div>
              </div>
              <div className="contact_lable">
                <div className="relative upload_input">
                  <input
                    id="resume"
                    name="resume"
                    type="file"
                    className={`upload-button-wrapper-input upload_file_input ${
                      inquiryObj.resume ? "ng-not-empty" : "ng-empty"
                    } ${errors.resume ? "ng-invalid" : "ng-valid"} ${
                      inquiryObj.resume ? "ng-touched" : ""
                    } ${formSubmitted && errors.resume ? "error" : ""}`}
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                    tabIndex={6}
                  />
                  <div className="upload-button-wrapper">
                    {!resumeFile ? (
                      <p className="transition_0s lable_error">
                        Resume Attachment
                      </p>
                    ) : (
                      <p className="transition_0s">{resumeFile.name}</p>
                    )}
                    <img
                      src="/images/icon/upload-cloud.svg"
                      alt="Resume Upload"
                      style={{ margin: 0 }}
                    />
                  </div>
                  <p className="other_message">
                    Allow only pdf, doc, docx file.
                  </p>
                </div>
              </div>

              <p className="relative check_box_error get_update_text align_center">
                <input
                  className="get_update_checkbox"
                  type="checkbox"
                  id="agree_tandc"
                  tabIndex={7}
                  name="agree_tandc"
                  aria-required="true"
                  aria-invalid="true"
                />
                <label className="darkgray-font" htmlFor="agree_tandc">
                  Keep me updated.
                </label>
              </p>

              <div className="submit-button border-div-venus-wrapper submit-button-contact form_button">
                <button
                  className="reecosys-template-button button-style-secondary "
                  type="submit"
                  tabIndex={8}
                >
                  {formSubmitted &&
                  Object.values(errors).every((err) => err === "") ? (
                    <span>Please Wait...</span>
                  ) : (
                    <span>Apply</span>
                  )}
                  {/* <span className="material-symbols-outlined">arrow_forward</span> */}
                </button>
              </div>
            </div>
          </form>
          {/* Put your existing form here */}
        </div>
      </div>
    </>
  );
}

export default Job;
